module.exports = __webpack_public_path__ + "img/head-mv01.00305a92.jpg";